// DAY-DIRECTSTAFF-2026-11-08 §1: "Ready to present" on Today -- the candidates the hub's profile_ready_unpresented view lists
// (submission-ready, never presented to a facility), with the open portal requests beside them, and the request the Present panel
// chooses first when opened from Today. A request for another discipline is said, never hidden: whether to present is staff's call.
// Ids, disciplines and states only.
import { cardDiscipline } from './workView';

const s = (v) => String(v == null ? '' : v).trim();
const isTest = (c) => !c || (Array.isArray(c.tags) && c.tags.some((x) => s(x).toLowerCase() === 'test')) || !!c.merged_into || !!c.test_marked_at;

/**
 * rows: profile_ready_unpresented ({ candidate_id, discipline, ready_since, days_ready }), null = the view is not readable;
 * candidates; waiting: the portal requests waiting (lib/facilityPortal.js waitingFromRows: { id, discipline, state, facility })
 * -> [{ candidate, id, discipline, days, since, requests: [{ id, facility, discipline, state, fits }] }], longest ready first
 */
export function readyToPresent({ rows = null, candidates = [], waiting = [] }) {
  const byId = new Map((candidates || []).map((c) => [String(c.id), c]));
  const out = [];
  for (const r of rows || []) {
    const c = byId.get(String(r.candidate_id));
    if (isTest(c)) continue;
    const discipline = cardDiscipline(c, { discipline: r.discipline });
    const requests = (waiting || []).map((q) => {
      const d = s(q.discipline).toUpperCase();
      return { id: Number(q.id), facility: s(q.facility) || 'A facility', discipline: d, state: s(q.state).toUpperCase(), fits: !d || !discipline || d === discipline };
    }).sort((a, b) => a.id - b.id);
    out.push({ candidate: c, id: Number(r.candidate_id), discipline, days: Number(r.days_ready) || 0, since: s(r.ready_since), requests });
  }
  return out.sort((a, b) => b.days - a.days || a.id - b.id);
}

/** "Ready to present: candidate 81 · PTA · ready 2 days · not presented to any facility" */
export const readyLine = (x) => `Ready to present: candidate ${x.id}${x.discipline ? ` · ${x.discipline}` : ''} · ready ${x.days} day${x.days === 1 ? '' : 's'} · not presented to any facility`;

/** "Open request: PlayDate #6 asks for PT, not PTA" | "Open requests: A #6 (PTA, GA) fits · B #7 asks for OT, not PTA" | "No open portal request right now" */
export function fitLine(x) {
  const reqs = (x && x.requests) || [];
  if (!reqs.length) return 'No open portal request right now';
  const one = (q) => (q.fits ? `${q.facility} #${q.id} (${[q.discipline || 'any discipline', q.state].filter(Boolean).join(', ')}) fits`
    : `${q.facility} #${q.id} asks for ${q.discipline}, not ${x.discipline}`);
  return `Open request${reqs.length === 1 ? '' : 's'}: ${reqs.map(one).join(' · ')}`;
}

/** The request chosen first: the oldest real (not test) one for their discipline, else one with no discipline, else the oldest real
 *  one -- which may be for another discipline (disciplineWarning says so) -- else none. targets: lib/workView.js presentTargets. */
export function autoTarget(targets = [], discipline = '') {
  const real = (targets || []).filter((t) => !t.test);
  const order = (a, b) => (a.kind === b.kind ? (a.kind === 'request' ? a.id - b.id : 0) : a.kind === 'request' ? -1 : 1);
  const sorted = [...real].sort(order);
  const d = s(discipline).toUpperCase();
  const pick = (d && sorted.find((t) => t.discipline === d)) || sorted.find((t) => !t.discipline) || sorted[0];
  return pick ? pick.key : '';
}

/** '' | "Request 6 asks for PT; this card says PTA. Present only if the facility said a PTA would do." */
export function disciplineWarning(target, discipline) {
  const want = s(target && target.discipline).toUpperCase(); const have = s(discipline).toUpperCase();
  if (!target || !want || !have || want === have) return '';
  const which = target.kind === 'request' ? `Request ${target.id}` : `Website request ${s(target.id).slice(0, 8)}`;
  return `${which} asks for ${want}; this card says ${have}. Present only if the facility said a${/^[AEFHILMNORSX]/.test(have) ? 'n' : ''} ${have} would do.`;
}
